import { MDBCard, MDBCardBody, MDBIcon } from 'mdb-react-ui-kit';
import { useEffect, useMemo } from 'react';
import { Data } from '../../../../../../../service/global';
import { useTranslation } from 'react-i18next';
import { StatusIcon } from '../../../../../../../components/StatusIcon';
import { StandardBoxDTO } from '@scm/common-legacy';

export interface StandardBoxItemProps {
    box: StandardBoxDTO;
    onSelect: () => void;
}

export const StandardBoxItem = ({ box, onSelect }: StandardBoxItemProps) => {
    const { t } = useTranslation();
    const bg = useMemo(
        () => Data.esList[box.status[0]?.id]?.web?.level,
        [box, box.status, Data, Data.esList],
    );

    return (
        <div
            className="d-inline-block pt-3 pb-3 ps-1 pe-1 col-12 col-sm-6 col-md-6"
            onClick={onSelect}
        >
            <MDBCard
                className={`d-inline-block w-100 card-hover2 bg-opacity-25 bg-${bg}`}
            >
                <div
                    className="position-absolute d-flex justify-content-center w-100"
                    style={{ top: 0, marginTop: -10 }}
                >
                    <span className="badge rounded-pill badge-primary">
                        {box.nr + 1}
                    </span>
                </div>
                <MDBCardBody className="p-2" style={{ height: 62 }}>
                    <div className="d-flex justify-content-between px-md-1">
                        <div
                            className="text-start flex-fill"
                            style={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                            }}
                        >
                            <span
                                className="d-flex flex-row w-100 "
                                style={{
                                    fontWeight: 'bold',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                }}
                            >
                                {box.productName && (
                                    <>
                                        <span>
                                            <MDBIcon
                                                icon="shopping-basket"
                                                color="primary"
                                                className="me-1"
                                            />
                                        </span>
                                        <span
                                            style={{
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                            }}
                                        >
                                            {box.productName}
                                        </span>
                                    </>
                                )}
                                {!box.productName && (
                                    <>
                                        <span>
                                            <MDBIcon
                                                icon="circle-question"
                                                color="warning"
                                                className="me-1"
                                            />
                                        </span>
                                        <span className="text-warning">
                                            {t('unknown_product')}
                                        </span>
                                    </>
                                )}
                            </span>
                            <div
                                className="d-flex flex-row w-100"
                                style={{ whiteSpace: 'nowrap' }}
                            >
                                {box.price !== undefined && (
                                    <>
                                        <span
                                            className="badge badge-success text-dark me-1"
                                            style={{ height: 20 }}
                                            title={t('price')}
                                        >
                                            <MDBIcon
                                                icon="money-bill"
                                                color="success"
                                                className="me-1"
                                            />
                                            <span>{box.price}</span>
                                        </span>
                                    </>
                                )}
                                {box.qnty !== undefined && (
                                    <>
                                        <span
                                            className="badge badge-primary text-dark me-1"
                                            style={{ height: 20 }}
                                            title={t('quantity')}
                                        >
                                            <MDBIcon
                                                icon="shopping-cart"
                                                color="primary"
                                                className="me-1"
                                            />
                                            <span>{box.qnty}</span>
                                        </span>
                                    </>
                                )}

                                <div className="d-flex flex-row flex-fill justify-content-end">
                                    {box.status.map((s) => (
                                        <StatusIcon
                                            key={s.id}
                                            name={s.id}
                                            ts={s.ts}
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </MDBCardBody>
            </MDBCard>
        </div>
    );
};
